module.exports = __webpack_public_path__ + "6712e0e860511e6a8ada6dd01ecd2457.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-872.jpg
// module id = 220
// module chunks = 0